module.exports = __webpack_public_path__ + "static/media/0017.e3130a02.png";